import React, { useState } from 'react';
import './Contact.css';

const contactItems = [
  { icon: 'fas fa-map-marker-alt', title: 'Our Office', lines: ['No.2. Thirum, East Coast Road, Kovalam', 'Chengalpattu District, PIN-603112'] },
  { icon: 'fas fa-phone-alt', title: 'Call Us', lines: ['+91 84386 23133'], link: 'tel:+918438623133' },
  { icon: 'fas fa-envelope', title: 'Email Us', lines: ['vetrirealtorspvtltd@gmail.com'], link: 'mailto:vetrirealtorspvtltd@gmail.com' },
  { icon: 'fas fa-clock', title: 'Business Hours', lines: ['Mon – Sat: 9:00 AM – 7:00 PM', 'Sunday: By Appointment Only'] },
];

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const emailBody = `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nService: ${formData.service || 'Not specified'}\n\nMessage:\n${formData.message}`;
    window.location.href = `mailto:vetrirealtorspvtltd@gmail.com?subject=New%20Contact%20Request&body=${encodeURIComponent(emailBody)}`;
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    }, 1000);
  };

  return (
    <div className="contact-page page-container">

      {/* ── Page Hero ── */}
      <section className="contact-hero">
        <span className="section-eyebrow">Let's Talk</span>
        <h1 className="contact-hero-title">
          Get In Touch With <span className="amber-text">Vetri Realtors</span>
        </h1>
        <p className="contact-hero-sub">
          Whether you're buying, selling, or just exploring — our team is ready to guide you every step of the way.
        </p>
      </section>

      {/* ── Info Cards Row ── */}
      <section className="contact-cards-row">
        {contactItems.map(({ icon, title, lines, link }) => (
          <div key={title} className="contact-info-card card-hover">
            <div className="contact-card-icon-wrap">
              <i className={`${icon} contact-card-icon`} />
            </div>
            <h3>{title}</h3>
            {lines.map((line, i) =>
              link && i === 0
                ? <a key={i} href={link} className="contact-card-link">{line}</a>
                : <p key={i}>{line}</p>
            )}
          </div>
        ))}
      </section>

      {/* ── Form + Map area ── */}
      <section className="contact-main">
        <div className="contact-form-wrap">
          <h2 className="contact-form-heading">Send Us a Message</h2>
          <p className="contact-form-sub">Fill in the form and we'll get back to you within 24 hours.</p>

          {submitted && (
            <div className="form-success">
              <i className="fas fa-check-circle success-icon" />
              <p>Thank you! We've received your message. We'll be in touch shortly.</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="contact-form-inner">
            <div className="form-row">
              <div className="form-group">
                <label>Your Name</label>
                <input type="text" name="name" placeholder="e.g. Ravi Kumar" required value={formData.name} onChange={handleInputChange} className="glass-input" />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" name="phone" placeholder="+91 XXXXX XXXXX" value={formData.phone} onChange={handleInputChange} className="glass-input" />
              </div>
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" placeholder="your@email.com" required value={formData.email} onChange={handleInputChange} className="glass-input" />
            </div>
            <div className="form-group">
              <label>Service Interested In</label>
              <select name="service" value={formData.service} onChange={handleInputChange} className="glass-input">
                <option value="">Select a service...</option>
                <option value="farm-land">Farm Land Purchase / Sale</option>
                <option value="residential">Residential Plots</option>
                <option value="ecr-omr">ECR / OMR Properties</option>
                <option value="legal">Legal Consultation</option>
                <option value="registration">Registration Process</option>
                <option value="investment">Investment Advisory</option>
              </select>
            </div>
            <div className="form-group">
              <label>Your Message</label>
              <textarea name="message" placeholder="Tell us about your requirements..." rows="5" required value={formData.message} onChange={handleInputChange} className="glass-input" />
            </div>
            <button type="submit" className="cta-button cta-pulse" disabled={isSubmitting}>
              {isSubmitting ? <><i className="fas fa-spinner fa-spin" /> Sending...</> : <><i className="fas fa-paper-plane" /> Send Message</>}
            </button>
          </form>
        </div>

        {/* Aside CTA */}
        <div className="contact-aside">
          <div className="contact-aside-card">
            <i className="fas fa-phone-alt contact-aside-icon" />
            <h3>Prefer to call?</h3>
            <p>Our team is available Monday to Saturday, 9 AM – 7 PM</p>
            <a href="tel:+918438623133" className="cta-button" style={{ marginTop: '1.5rem' }}>
              <i className="fas fa-phone-alt" /> +91 84386 23133
            </a>
          </div>
          <div className="contact-aside-card">
            <i className="fab fa-whatsapp contact-aside-icon whatsapp-icon" />
            <h3>Chat on WhatsApp</h3>
            <p>Quick questions? Let's connect instantly on WhatsApp.</p>
            <a href="https://wa.me/918438623133" target="_blank" rel="noreferrer" className="cta-button" style={{ marginTop: '1.5rem', background: 'linear-gradient(135deg,#25D366,#128C7E)' }}>
              <i className="fab fa-whatsapp" /> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;